import styled from "styled-components";
import distances from "styles/distances.js";
import mediaQuery from "styles/mediaQuery";

const MainWrapper = styled.div`
  padding: 0 ${distances.pageMarginBig}rem;
  width: 100%;
  position: relative;
  height: 100%;
box-sizing: border-box;
  @media (max-width: ${mediaQuery.tablet}) {
    padding: 0 ${distances.pageMarginSmall}rem;
    width: 100%;

  }
`;

export default MainWrapper;
